module.exports = __webpack_public_path__ + "96bcaf515bbe704685f9c25ace457005.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/take_two_interactive_software_2021_chart.png
// module id = 1736
// module chunks = 0